import {actionTypes} from '../const';
import * as constants from "../const";
import { LOCATION_CHANGE } from 'react-router-redux';
const initialState = {
    trainNum:'',
    division:'NA',
    employeeId:'',
    employeeFirstName:'',
    employeeLastName:'',
    jobClass:'NA',
    jobType:0,
    workdayDateFrom: '',
    workdayDateTo: '',
    outlaw:false,
    showFilter:false,
    byFilter:false,
    fromLocation:'-',
    toLocation:'-',
    fromTime:'',
    toTime:'',
    fromTimeCondition:'0',
    toTimeCondition:'0',
    showNonRegisteredEmp:false,
    auditFromDate:'',
    auditToDate:'',
    operationType:'',
    tableType:'',
    fieldType:'',
    excludeOFFDays:true
}

const filter = (state = initialState, action) => {
    switch (action.type) {
        case LOCATION_CHANGE: {
            return state = initialState;
        }
        case actionTypes.LOCATION_SUCCESS:
            return Object.assign({}, state, {
                locations:action.locations
        });
        case actionTypes.FILTER_SUCCESS:    
            return Object.assign({}, state, 
                action.filterObj
            );
        case actionTypes.RESET_FILTER_SUCCESS:
            return Object.assign({}, state, 
                //defaultState:action.filterObj,
                initialState
            );
        case actionTypes.EMPLIST_SUCCESS:
            return Object.assign({}, state, {
                employees:action.employees
        });
        default:
            return state;
    }
}
export default filter